/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiRateLimitEndpoint
 */
export interface InternalApiRateLimitEndpoint {
    /**
     * 
     * @type {string}
     * @memberof InternalApiRateLimitEndpoint
     */
    endpointName: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiRateLimitEndpoint
     */
    endpointPath: string;
}

/**
 * Check if a given object implements the InternalApiRateLimitEndpoint interface.
 */
export function instanceOfInternalApiRateLimitEndpoint(value: object): value is InternalApiRateLimitEndpoint {
    if (!('endpointName' in value) || value['endpointName'] === undefined) return false;
    if (!('endpointPath' in value) || value['endpointPath'] === undefined) return false;
    return true;
}

export function InternalApiRateLimitEndpointFromJSON(json: any): InternalApiRateLimitEndpoint {
    return InternalApiRateLimitEndpointFromJSONTyped(json, false);
}

export function InternalApiRateLimitEndpointFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiRateLimitEndpoint {
    if (json == null) {
        return json;
    }
    return {
        
        'endpointName': json['endpointName'],
        'endpointPath': json['endpointPath'],
    };
}

export function InternalApiRateLimitEndpointToJSON(json: any): InternalApiRateLimitEndpoint {
    return InternalApiRateLimitEndpointToJSONTyped(json, false);
}

export function InternalApiRateLimitEndpointToJSONTyped(value?: InternalApiRateLimitEndpoint | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'endpointName': value['endpointName'],
        'endpointPath': value['endpointPath'],
    };
}

